import React from 'react'
import { mq } from '../../utils'
import { Text } from '../Text'
import { IProps } from './index'
import { HeroHeadings as HeroHeadingsDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export const HeroHeadings = (props: IProps): React.ReactElement => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <HeroHeadingsDefault {...props} />
  }
  return <HeroHeadingsLegacy {...props} />
}

const HeroHeadingsLegacy = ({
  eyebrow,
  headline,
  headline2,
  largeFont,
  subheading,
  placeContentAfter,
  children,
}: IProps): React.ReactElement => {
  function renderContentAfter(section: string) {
    return placeContentAfter && placeContentAfter === section && children
  }
  return (
    <>
      {eyebrow && (
        <>
          <div className="eyebrow">
            <Text brand="legacy" size="lg-eyebrow">
              {eyebrow}
            </Text>
          </div>
          {renderContentAfter('eyebrow')}
        </>
      )}
      <h1 className="main-headline">
        <Text brand="legacy" size={largeFont ? 'heading+' : 'heading'}>
          {headline}
        </Text>
      </h1>
      {renderContentAfter('headline')}

      {headline2 && (
        <>
          <h1 className="headline2">
            <Text brand="legacy" size={largeFont ? 'heading+' : 'heading'}>
              {headline2}
            </Text>
          </h1>
          {renderContentAfter('headline2')}
        </>
      )}
      {subheading && (
        <>
          <div className="subheading">
            <Text brand="legacy" size="lg">
              {subheading}
            </Text>
          </div>
          {renderContentAfter('subheading')}
        </>
      )}
      <style jsx>
        {`
          .eyebrow {
            margin-bottom: 14px;
          }
          .main-headline {
            max-width: 1024px;
            margin-bottom: ${headline2 ? '5px' : subheading ? '16px' : '24px'};
            margin-top: 0;
          }
          .headline2 {
            max-width: 1024px;
            margin-bottom: ${subheading ? '16px' : '24px'};
            margin-top: 0;
          }
          .subheading {
            margin-bottom: 21px;
          }
          @media (${mq.tablet}) {
            .eyebrow {
              margin-bottom: 28px;
            }
            .main-headline {
              margin-bottom: ${headline2 ? '5px' : subheading ? '24px' : '36px'};
            }
            .headline2 {
              margin-bottom: ${subheading ? '24px' : '36px'};
            }
            .subheading {
              margin: var(--margin);
              margin-bottom: 36px;
              max-width: 800px;
            }
          }
        `}
      </style>
    </>
  )
}
